module.exports = __webpack_public_path__ + "static/AviaryAttorney1-c7f061322439daa3a75a2b9a64fa45ac.webp";